var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0042 0.318359H9.69294C9.14294 0.318359 8.69709 0.764203 8.69709 1.3142C8.69709 1.8642 9.14294 2.31005 9.69294 2.31005H12.6L8.51741 6.39255L5.90216 3.77705C5.51322 3.38808 4.88259 3.38805 4.49363 3.77702L0.291656 7.97927C0.104906 8.16602 0 8.4193 0 8.68339C0 9.57058 1.07266 10.0149 1.7 9.38758L5.19794 5.88977L7.81328 8.50486C8.20219 8.89373 8.83269 8.8937 9.22156 8.50483L14.0083 3.7183V6.62539C14.0083 7.17539 14.4541 7.62123 15.0041 7.62123C15.5541 7.62123 16 7.17539 16 6.62539V1.3142C16 0.764203 15.5542 0.318359 15.0042 0.318359Z",
    fill: "#098B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.7d2e519eb220ee86e5903a7e6180745f.svg";
export { ForwardRef as ReactComponent };